import {AppliedDiscountDiscountTypeWithLiterals, Coupon} from '@wix/auto_sdk_ecom_current-cart';
import {ModelContext} from '../../../types/app.types';
import {SPECS} from '../../specs';

export class CouponModel {
  public id: string;
  public code: string;
  public discountType: AppliedDiscountDiscountTypeWithLiterals;

  constructor(params: CouponModel) {
    this.id = params.id;
    this.code = params.code;
    this.discountType = params.discountType;
  }

  public static fromCartV1(
    coupon: Coupon,
    discountType: AppliedDiscountDiscountTypeWithLiterals,
    modelContext: ModelContext
  ) {
    return new CouponModel({
      id: coupon?._id,
      code: coupon?.code,
      discountType: modelContext.viewerContext.isExperimentEnabled(SPECS.RefactorCouponOnCart)
        ? undefined
        : discountType,
    });
  }
}
